import React from "react";
import "./PrivacyPolicy.css";
import lubecoLogo from '../../assets/img/lubeco_smart_white-removebg.png'
import chemcoolxLogo from '../../assets/img/logo2.png'

const PrivacyPolicy = () => {
    return (
        <div className="privacy-container">
            <div className="privacy-content">
                {/* Header with Logo */}
                <div className="privacy-header">
                    <img src={lubecoLogo} alt="Lubeco Logo" />
                    <h1 style={{ color: "white" }}>Privacy Policy</h1>
                    <p>Lubeco Smart Lubrication Management System</p>
                </div>

                {/* Main Content */}
                <div className="privacy-body">
                    {/* Introduction */}
                    <div className="privacy-section">
                        <h2>Introduction</h2>
                        <p>
                            This Privacy Policy explains how Lubeco collects, uses, and
                            protects your information when you use our mobile application. We
                            are committed to maintaining your privacy and ensuring
                            transparency in all our data practices.
                        </p>
                    </div>

                    {/* Information We Collect */}
                    <div className="privacy-section">
                        <h2>Information We Collect</h2>
                        <p>
                            The Lubeco application does not collect any personal information
                            from end users beyond what is necessary for application
                            functionality. Users log in using their email and password, which
                            are stored securely using industry-standard encryption methods.
                        </p>
                        <ul>
                            <li>Email and password for authentication</li>
                            <li>Application usage data for improving user experience</li>
                            <li>Machine and maintenance records entered by the user</li>
                        </ul>
                    </div>

                    {/* How We Use Your Information */}
                    <div className="privacy-section">
                        <h2>How We Use Your Information</h2>
                        <p>
                            The information provided by the user is used solely for the
                            functionality of the application, such as:
                        </p>
                        <ul>
                            <li>Generating maintenance logs and reports</li>
                            <li>Sending notifications based on the data entered</li>
                            <li>Maintaining machine and lubrication records</li>
                            <li>Providing personalized recommendations</li>
                        </ul>
                    </div>

                    {/* Data Sharing */}
                    <div className="privacy-section">
                        <h2>Data Sharing</h2>
                        <p>
                            We do not share user data with any third parties unless required
                            by law. Your data remains confidential and is only accessed by
                            authorized personnel when necessary for support or maintenance
                            purposes.
                        </p>
                    </div>

                    {/* Data Security */}
                    <div className="privacy-section">
                        <h2>Data Security</h2>
                        <p>
                            We take data security seriously and implement appropriate
                            technical and organizational measures to protect your information
                            from unauthorized access, loss, or misuse. Our security measures
                            include:
                        </p>
                        <ul>
                            <li>End-to-end encryption for sensitive data</li>
                            <li>Secure authentication mechanisms</li>
                            <li>Regular security audits and updates</li>
                            <li>Compliance with data protection standards</li>
                        </ul>
                    </div>

                    {/* User Rights */}
                    <div className="privacy-section">
                        <h2>User Rights</h2>
                        <p>
                            Since the application does not collect extensive personal data,
                            there are no specific rights related to personal data processing
                            under this policy. However, users can contact us to:
                        </p>
                        <ul>
                            <li>Inquire about information stored under their account</li>
                            <li>Request data corrections or updates</li>
                            <li>Discuss data retention or deletion options</li>
                        </ul>
                    </div>

                    {/* Cookies and Tracking */}
                    <div className="privacy-section">
                        <h2>Cookies and Tracking</h2>
                        <p>
                            The Lubeco application does not use cookies or other tracking
                            technologies for analytics or marketing purposes. We respect your
                            privacy and do not track user behavior across other platforms.
                        </p>
                    </div>

                    {/* Changes to this Privacy Policy */}
                    <div className="privacy-section">
                        <h2>Changes to this Privacy Policy</h2>
                        <p>
                            We may update this Privacy Policy from time to time to reflect
                            changes in our practices or legal requirements. Changes will be
                            posted within the application, and your continued use of the app
                            constitutes acceptance of the updated policy. We encourage you to
                            review this policy periodically.
                        </p>
                    </div>

                    {/* Contact Information */}
                    <div className="privacy-section">
                        <h2>Contact Information</h2>
                        <p>
                            If you have any questions, concerns, or feedback about this
                            Privacy Policy or our privacy practices, please don't hesitate to
                            contact us.
                            <br />
                            Email: {" "}chemcoolx@gmail.com
                        </p>
                    </div>

                    <div className="last-updated">
                        <p>Last Updated: December 11, 2025</p>
                    </div>
                </div>

                {/* Footer */}
                <div className="privacy-footer">
                    <p>&copy; 2025 Lubeco. All rights reserved.</p>
                    <p>This Privacy Policy is effective as of the date listed above.</p>
                    <div
                        style={{
                            marginTop: "12px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "5px",
                        }}
                    >
                        <div>Powered by</div>
                        <div>
                            <img
                                src={chemcoolxLogo}
                                alt="ChemcoolX Logo"
                                style={{ height: "12px", verticalAlign: "middle" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
